import { render, staticRenderFns } from "./Numpad.vue?vue&type=template&id=35b97fce&scoped=true&"
import script from "./Numpad.vue?vue&type=script&lang=js&"
export * from "./Numpad.vue?vue&type=script&lang=js&"
import style0 from "./Numpad.vue?vue&type=style&index=0&id=35b97fce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b97fce",
  null
  
)

export default component.exports